
import { dmApi } from "../../../app/dmApi";
import { getAuthorizationHeader, handleQueryError, handleQueryErrorAndSuccess } from "../../../helpers/RtkQueryUtils";
import { serialize } from "../../../helpers/Utils";


export const ripeningDashboardApi = dmApi.injectEndpoints({
    endpoints: (build) => ({
        searchRipeningBarChart: build.query({
            query: (data) => {
                let paramData = serialize(data);
                return {
                    url: `/ripening-data/bar-chart-data?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['ripeningBarChart'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        searchRipeningPieChart: build.query({
            query: (data) => {
                let paramData = serialize(data);

                return {
                    url: `/ripening-data/pie-chart-data?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['ripeningPieChart'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        searchSortingPieChart: build.query({
            query: (data) => {
                let paramData = serialize(data);

                return {
                    url: `/sorting/pie-chart-data?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['sortingPieChart'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },

        }),
        getEmployee: build.query({
            query: (data) => {
                let paramData = serialize(data);
                return {
                    url: `/ripening-data/employees-data?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['employee'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        getWashingSummary: build.query({
            query: (data) => {
                let paramData = serialize(data);
                return {
                    url: `/washing/summary?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['washingSummary'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        getRipeningSummary: build.query({
            query: (data) => {
                let paramData = serialize(data);
                return {
                    url: `/ripening-data/summary?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['ripeningSummary'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        getRipeningColdStorageSummary: build.query({
            query: (data) => {
                let paramData = serialize(data);
                return {
                    url: `/cold-storage/summary?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['ripeningColdStorageSummary'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        createRipeningEmployeeData: build.mutation({
            query: (requestBody) => {
                return {
                    url: `/ripening-data/employees-data/store`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['addEmployee', 'employee'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Added", "Employee Data")
            },

        }),

        // ########### RIPENING DASHBOARD OVERVIEW ###########
        
        getRipeningDashboard: build.query({
            query: (data) => {
                let paramData = serialize(data);
                return {
                    url: `/ripening-data/overview?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['ripeningDashboardOverview'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),

    }),

});

export const {
    useSearchRipeningPieChartQuery,
    useSearchRipeningBarChartQuery,
    useSearchSortingPieChartQuery,
    useGetEmployeeQuery,
    useCreateRipeningEmployeeDataMutation,
    useGetWashingSummaryQuery,
    useGetRipeningSummaryQuery,
    useGetRipeningColdStorageSummaryQuery,
    useGetRipeningDashboardQuery
} = ripeningDashboardApi;

